import {
  Input as NextUIInput,
  InputProps as NextUIInputProps,
} from "@heroui/react";
import { CounterRow, useHandleInputValueChange } from "ds/utils/input";
import { getInputClassNames } from "ds/utils/styles";

type Color = Extract<NextUIInputProps["color"], "default">;
type LabelPlacement = Extract<
  NextUIInputProps["labelPlacement"],
  "outside" | "outside-top"
>;
type Variant = Extract<NextUIInputProps["variant"], "bordered">;

export type InputProps = Omit<
  NextUIInputProps,
  "color" | "labelPlacement" | "variant"
> & {
  color?: Color;
  labelPlacement?: LabelPlacement;
  variant?: Variant;
  ref?: React.Ref<HTMLInputElement>;
};

export function Input({
  labelPlacement,
  placeholder = " ",
  ref,
  ...props
}: InputProps) {
  const { handleValueChange, valueLength } = useHandleInputValueChange({
    defaultValue: props.defaultValue,
    maxLength: props.maxLength,
    onValueChange: props.onValueChange,
    value: props.value,
  });

  return (
    <NextUIInput
      ref={ref}
      classNames={getInputClassNames(props.size)}
      color="default"
      data-testid={props.name}
      labelPlacement={labelPlacement ?? "outside"}
      placeholder={placeholder}
      variant="bordered"
      {...props}
      description={
        <CounterRow
          left={props.description}
          maxLength={props.maxLength}
          value={props.value}
          valueLength={valueLength}
        />
      }
      errorMessage={
        typeof props.errorMessage === "string" ? (
          <CounterRow
            left={props.errorMessage}
            maxLength={props.maxLength}
            value={props.value}
            valueLength={valueLength}
          />
        ) : (
          props.errorMessage
        )
      }
      onValueChange={handleValueChange}
    />
  );
}

Input.displayName = "RecareUI.Input";
